import script from "./TextTitle.vue?vue&type=script&setup=true&lang=js"
export * from "./TextTitle.vue?vue&type=script&setup=true&lang=js"

import "./TextTitle.vue?vue&type=style&index=0&id=369e0c69&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-369e0c69"]])

export default __exports__